export const isRealDate = (date: string): boolean => {
  return !!date && date.length === 10 && !!Date.parse(date);
};
